import _createForOfIteratorHelper from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/selectcolumncommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import TableWalker from '../tablewalker';
import { getSelectionAffectedTableCells } from '../utils/selection';
/**
 * The select column command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as the `'selectTableColumn'` editor command.
 *
 * To select the columns containing the selected cells, execute the command:
 *
 *		editor.execute( 'selectTableColumn' );
 *
 * @extends module:core/command~Command
 */

var SelectColumnCommand = /*#__PURE__*/function (_Command) {
  _inherits(SelectColumnCommand, _Command);

  var _super = _createSuper(SelectColumnCommand);

  function SelectColumnCommand() {
    _classCallCheck(this, SelectColumnCommand);

    return _super.apply(this, arguments);
  }

  _createClass(SelectColumnCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var selectedCells = getSelectionAffectedTableCells(this.editor.model.document.selection);
      this.isEnabled = selectedCells.length > 0;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute() {
      var model = this.editor.model;
      var referenceCells = getSelectionAffectedTableCells(model.document.selection);
      var firstCell = referenceCells[0];
      var lastCell = referenceCells.pop();
      var table = firstCell.findAncestor('table');
      var tableUtils = this.editor.plugins.get('TableUtils');
      var startLocation = tableUtils.getCellLocation(firstCell);
      var endLocation = tableUtils.getCellLocation(lastCell);
      var startColumn = Math.min(startLocation.column, endLocation.column);
      var endColumn = Math.max(startLocation.column, endLocation.column);
      var rangesToSelect = [];

      var _iterator = _createForOfIteratorHelper(new TableWalker(table, {
        startColumn: startColumn,
        endColumn: endColumn
      })),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var cellInfo = _step.value;
          rangesToSelect.push(model.createRangeOn(cellInfo.cell));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      model.change(function (writer) {
        writer.setSelection(rangesToSelect);
      });
    }
  }]);

  return SelectColumnCommand;
}(Command);

export { SelectColumnCommand as default };